import React from "react";
import Leaflet from 'leaflet';
import { MapContainer, TileLayer, Marker,Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
Leaflet.Icon.Default.imagePath = '//cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.4/images/'; 

class MapComponent extends React.Component{
  
  render(){
    
    const position = [43.75644474864381, 20.096151894882976];
    const address1 = [43.713572849237636, 20.158688951377844];
    const text = Leaflet.divIcon({html: "Drenovac doo"});
    const address2 = [43.79986280758416, 20.096103909159165];
    const address3 = [43.7479621198487, 20.086805378672278];
    const address4 = [43.75046281136729, 20.090531379235863];

    return(
      <MapContainer center={position} zoom={11} scrollWheelZoom={false} style={{height : '400px'}}>
        <TileLayer
          attribution='&copy; <a href=“https://www.openstreetmap.org/copyright”>OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={position} >
          <Popup>
            <h3>Udruženje Ariljska malina</h3>
            <p>Masarikova 1, 31320 Arilje, Serbia</p>
          </Popup>
        </Marker>
        <Marker position={address1} >
          <Popup>
            <h3>Drenovac doo</h3>
            <p>Mirosaljci bb, 31230 Arilje, Serbia</p>
          </Popup>
        </Marker>
        <Marker position={address2} >
          <Popup>
            <h3>Frigo Junior doo</h3>
            <p>Vigošte bb, 31230 Arilje, Serbia</p>
          </Popup>
        </Marker>
        <Marker position={address3} >
          <Popup>
            <h3>OZZ Agro Eko Voće</h3>
            <p>Boška Buhe bb, 31230 Arilje, Serbia</p>
          </Popup>
        </Marker>
        <Marker position={address4} >
          <Popup>
            <h3>Nectar doo</h3>
            <p>Ive Lole Ribara bb, 31230 Arilje, Serbia</p>
          </Popup>
        </Marker>
      </MapContainer>
    );
  }
}
export default MapComponent;


